var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Star Empty",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.585 13.856"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10328",
    d: "M7.293 0l2.279 4.558 5.014.729-3.647 3.555.82 5.014-4.467-2.37-4.467 2.37.82-5.014L0 5.287l5.014-.729z"
  })));
}
export default SvgStar;